import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import type { DeadlineOutput } from "@/types";

type Params = {
  account_id: string;
  role: string;
};

export function useProjectDeadline(params: Params) {
  const query = buildParams(params);

  return useQuery({
    queryKey: ["project-deadline", params],
    queryFn: () => apiFetch<DeadlineOutput>(`/v1/home/project-deadline${query}`),
    enabled: true, // TODO: remove when API is ready
  });
}
